import { AbstractControl, ValidationErrors } from '@angular/forms';

export class WhitespaceValidator {
  public static noWhitespace(control: AbstractControl): ValidationErrors {
    if (typeof control.value !== 'string') {
      return undefined;
    }
    if (!(control.value as string).trim()) {
      return { whitespace: true };
    }
    return undefined;
  }
}
